import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const WYSIWYGEditor = ({ onChange, value }) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [updated, setUpdated] = useState(false);
  
    useEffect(() => {
      if (!updated) {
        const defaultValue = value ? value : "";
        const blocksFromHtml = htmlToDraft(defaultValue);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHtml.contentBlocks,
          blocksFromHtml.entityMap
        );
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
    }, [value]);
  
    const onEditorStateChange = (editorState) => {
      setUpdated(true);
      setEditorState(editorState);
  
      return onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    };

    // "html-to-draftjs": "1.5.0",
    // "react-draft-wysiwyg": "^1.14.7",
    // "html-react-parser": "^1.2.6",
    // "draftjs-to-html": "^0.9.1",
  
  
    return (
      <React.Fragment>
        <div className="editor">
          <Editor
            spellCheck
            editorState={editorState}
            onEditorStateChange={onEditorStateChange}
          />
        </div>
      </React.Fragment>
    );
  };
  
  export default WYSIWYGEditor;